import { ApplicationRef, Component } from '@angular/core';
import { ToastNoAnimation, ToastPackage, ToastRef, ToastrService } from 'ngx-toastr';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { IconBackground } from '../icon-message-toaster-element/icon-message-toaster-element.component';
import { NotificationActionButton } from '../../../services/notification-toaster.service';

@Component({
  selector: 'app-custom-notification-toaster-v2',
  templateUrl: './custom-notification-toaster-v2.component.html',
  styleUrls: ['./custom-notification-toaster-v2.component.scss'],
})
export class CustomNotificationToasterV2Component extends ToastNoAnimation {
  toastRef: ToastRef<any>;
  protected readonly IconBackground = IconBackground;
  protected readonly IconTypes = IconTypes;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    protected appRef: ApplicationRef,
  ) {
    super(toastrService, toastPackage, appRef);
    this.toastRef = toastPackage.toastRef;
  }

  onClose() {
    // Close the toast using the toastr service rather than the toastr ref
    this.toastrService.remove(this.toastPackage.toastId);
  }

  handleActionButtonClick(button?: NotificationActionButton) {
    if (button?.onClick) {
      button?.onClick();
    }

    if (button?.close) {
      this.onClose();
    }
  }
}
